import styled from '@emotion/styled';

export const HeaderQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #b7bdcb;
  margin: 0;
  width: 100%;
`;

// export const ListenQuestionButton = styled.button`
//   font-family: 'Inter', sans-serif;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   height: 36px;
//   gap: 12px;
//   padding: 9px 12px;
//   border-radius: 999px;
//   background: #23252a;
//   border: 1px solid #2b2d33;
//   font-size: 14px;
//   font-weight: 500;
//   color: #e9ecf5;
//   cursor: pointer;
// `;


export const Speaker = styled.img`
  width: 21px;
  height: 18px;
`;

export const TranscriptHeader = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #b7bdcb;
  margin: 0;
`;
